/* Native disclosure navigation and search remain usable without JavaScript. */
(function () {
  'use strict';
  var menus = [];
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  function close(menu, restoreFocus) {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary').focus();
  }
  function scan(scope) {
    menus = menus.filter(function (menu) { return menu.isConnected; });
    scope.querySelectorAll('[data-site-menu]').forEach(function (menu) {
      if (menu.__siteMenu) return;
      menu.__siteMenu = true;
      menus.push(menu);
      menu.addEventListener('focusout', function () {
        window.requestAnimationFrame(function () {
          if (!menu.contains(document.activeElement)) close(menu, false);
        });
      });
      menu.addEventListener('click', function (event) {
        if (event.target.closest('a')) close(menu, false);
      });
      var header = menu.closest('.site-header');
      var backdrop = header && header.querySelector('[data-menu-backdrop]');
      var label = menu.querySelector('[data-menu-label]');
      var icon = menu.querySelector('[data-menu-icon]');
      var closedLabel = label ? label.textContent : '';
      menu.addEventListener('toggle', function () {
        var open = menu.open;
        if (label) label.textContent = open ? 'Close' : closedLabel;
        if (icon) icon.textContent = open ? '✕' : '☰';
        if (backdrop) backdrop.hidden = !open;
        document.documentElement.classList.toggle('menu-open', open);
        if (!open && menu.contains(document.activeElement) === false && menu.__returnFocus) menu.querySelector('summary').focus();
        menu.__returnFocus = false;
      });
      if (backdrop) backdrop.addEventListener('click', function () { menu.__returnFocus = true; close(menu, false); });
    });
    scope.querySelectorAll('[data-site-search]').forEach(function (form) {
      if (form.__siteSearch) return;
      form.__siteSearch = true;
      var input = form.querySelector('[name="q"]');
      if (!input) return;
      input.addEventListener('input', function () { input.setCustomValidity(''); });
      form.addEventListener('submit', function (event) {
        input.value = input.value.trim();
        input.setCustomValidity(input.value ? '' : 'Enter a product, vehicle or guide to search for.');
        if (!input.value) {
          event.preventDefault();
          input.reportValidity();
          input.focus();
        }
      });
    });
  }
  function resize() {
    if (!desktop || !desktop.matches) return;
    menus.forEach(function (menu) {
      var focused = menu.contains(document.activeElement);
      var href = document.activeElement && document.activeElement.getAttribute('href');
      close(menu, false);
      if (focused) {
        var header = menu.closest('.site-header');
        var links = header.querySelectorAll('.site-header__nav a');
        var target;
        links.forEach(function (link) { if (href && link.getAttribute('href') === href) target = link; });
        (target || header.querySelector('.wordmark')).focus();
      }
    });
  }
  function start() {
    scan(document);
    document.addEventListener('click', function (event) {
      menus.forEach(function (menu) { if (!menu.contains(event.target)) close(menu, false); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      menus.forEach(function (menu) {
        if (menu.open) { close(menu, true); event.preventDefault(); }
      });
    });
    if (desktop) {
      if (desktop.addEventListener) desktop.addEventListener('change', resize);
      else if (desktop.addListener) desktop.addListener(resize);
    }
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); resize(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
